/**
 * durex-slide-ride.js
 * Durex Slide & Ride Landing Page — Interactive JS
 * Compatible with: Shopify Dawn 11.0.0
 */

(function () {
  'use strict';




  /* ─────────────────────────────────────────────
   * Image Gallery Carousel
   * Scroll-snap based — works with touch/swipe.
   * Syncs dot indicators to active slide.
   * ───────────────────────────────────────────── */
  function initGallery() {
    var track = document.getElementById('dsr-gallery-track');
    var dotsWrap = document.getElementById('dsr-gallery-dots');
    if (!track) return;

    var slides = track.querySelectorAll('.dsr-gallery__slide');
    var dots   = dotsWrap ? dotsWrap.querySelectorAll('.dsr-hero__dot') : [];
    if (slides.length <= 1) {
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    function setActive(idx) {
      dots.forEach(function(d, i) {
        d.classList.toggle('dsr-hero__dot--active', i === idx);
      });
    }

    // IntersectionObserver — fires when a slide is > 50% visible
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = parseInt(entry.target.dataset.index, 10);
          setActive(idx);
        }
      });
    }, { root: track, threshold: 0.5 });

    slides.forEach(function(slide) { observer.observe(slide); });

    // Dot tap — scroll to slide
    dots.forEach(function(dot, idx) {
      dot.style.cursor = 'pointer';
      dot.addEventListener('click', function() {
        var slide = slides[idx];
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
   * Benefit Tabs
   * ───────────────────────────────────────────── */
  function initBenefitTabs() {
    var tabsContainers = document.querySelectorAll('[data-dsr-tabs]');
    tabsContainers.forEach(function (container) {
      var tabs    = container.querySelectorAll('.dsr-btab');
      var panels  = container.querySelectorAll('.dsr-bcontent');

      function activate(idx) {
        tabs.forEach(function (t, i) {
          t.classList.toggle('dsr-btab--active', i === idx);
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        panels.forEach(function (p, i) {
          p.classList.toggle('dsr-bcontent--active', i === idx);
          p.hidden = i !== idx;
        });
      }

      tabs.forEach(function (tab, idx) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        tab.addEventListener('click', function () { activate(idx); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') activate((idx + 1) % tabs.length);
          if (e.key === 'ArrowLeft')  activate((idx - 1 + tabs.length) % tabs.length);
        });
      });

      activate(0);
    });
  }

  /* ─────────────────────────────────────────────
   * FAQ Accordion
   * ───────────────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.dsr-faq-item').forEach(function (item) {
      var trigger = item.querySelector('.dsr-faq-q');
      var answer  = item.querySelector('.dsr-faq-a');
      if (!trigger || !answer) return;

      var answerId = 'dsr-faq-' + Math.random().toString(36).substr(2, 6);
      answer.id = answerId;
      trigger.setAttribute('aria-controls', answerId);
      trigger.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', function () {
        var open = item.classList.contains('dsr-faq-item--open');

        // Close all first
        document.querySelectorAll('.dsr-faq-item--open').forEach(function (o) {
          o.classList.remove('dsr-faq-item--open');
          o.querySelector('.dsr-faq-q').setAttribute('aria-expanded', 'false');
        });

        if (!open) {
          item.classList.add('dsr-faq-item--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
   * Sticky CTA Bar
   * Hides when hero CTA is visible; shows on scroll
   * ───────────────────────────────────────────── */
  function initStickyBar() {
    var bar     = document.getElementById('dsr-sticky-bar');
    var heroCta = document.getElementById('dsr-hero-cta-anchor');
    if (!bar) return;

    // Mirror variant selection to sticky button
    document.querySelectorAll('.dsr-gk-buy-btn').forEach(function (btn) {
      bar.querySelector('.dsr-gk-buy-btn') && (
        btn.addEventListener('variantChange', function (e) {
          bar.querySelectorAll('[data-variant-id]').forEach(function (el) {
            el.dataset.variantId = e.detail.variantId;
          });
        })
      );
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('dsr-sticky-bar--hidden', entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    if (heroCta) {
      observer.observe(heroCta);
    } else {
      // Show after scrolling past hero
      var heroSection = document.getElementById('dsr-hero');
      if (heroSection) observer.observe(heroSection);
    }
  }

  /* ─────────────────────────────────────────────
   * Scroll Reveal
   * ───────────────────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.dsr-reveal').forEach(function (el) {
        el.classList.add('dsr-reveal--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dsr-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.dsr-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─────────────────────────────────────────────
   * WhatsApp Capture Sheet
   * Shows at 60% scroll depth, once per session
   * ───────────────────────────────────────────── */
  function initWhatsAppCapture() {
    var overlay = document.getElementById('dsr-wa-overlay');
    var sheet   = document.getElementById('dsr-wa-sheet');
    var skipBtn = document.getElementById('dsr-wa-skip');
    var form    = document.getElementById('dsr-wa-form');

    if (!overlay || !sheet) return;
    if (sessionStorage.getItem('dsr_wa_shown')) return;

    function openSheet() {
      overlay.classList.add('dsr-wa-overlay--open');
      sheet.classList.add('dsr-wa-sheet--open');
      sessionStorage.setItem('dsr_wa_shown', '1');
    }

    function closeSheet() {
      overlay.classList.remove('dsr-wa-overlay--open');
      sheet.classList.remove('dsr-wa-sheet--open');
    }

    // Trigger at 60% scroll depth
    var triggered = false;
    window.addEventListener('scroll', function () {
      if (triggered) return;
      var scrolled = window.scrollY + window.innerHeight;
      var total    = document.documentElement.scrollHeight;
      if (scrolled / total >= 0.60) {
        triggered = true;
        setTimeout(openSheet, 600);
      }
    }, { passive: true });

    overlay.addEventListener('click', closeSheet);
    skipBtn && skipBtn.addEventListener('click', closeSheet);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var phone = form.querySelector('input[type="tel"]').value.trim();
        if (!phone) return;
        // Klaviyo / custom submission can go here
        // For now store in sessionStorage and close
        sessionStorage.setItem('dsr_wa_phone', phone);
        closeSheet();
        // Redirect to WhatsApp if you have a WA link
        // window.open('https://wa.me/91XXXXXXXXXX', '_blank');
      });
    }
  }

  /* ─────────────────────────────────────────────
   * Variant Selector (if section exposes one)
   * Updates all GoKwik buttons on page
   * ───────────────────────────────────────────── */
  function initVariantSelector() {
    var selector = document.getElementById('dsr-variant-select');
    if (!selector) return;

    selector.addEventListener('change', function () {
      var variantId = this.value;
      document.querySelectorAll('.dsr-gk-buy-btn, [data-variant-id]').forEach(function (el) {
        el.dataset.variantId = variantId;
      });

      // Update price display
      var priceEls = document.querySelectorAll('[data-dsr-price]');
      var origEls  = document.querySelectorAll('[data-dsr-price-orig]');
      var opt = selector.querySelector('option[value="' + variantId + '"]');
      if (opt) {
        priceEls.forEach(function (el) { el.textContent = opt.dataset.price; });
        origEls.forEach(function (el)  { el.textContent = opt.dataset.priceOrig; });
      }
    });
  }

  /* ─────────────────────────────────────────────
   * UTM-based Dynamic Headline
   * ?angle=price|sensation|proof|default
   * ───────────────────────────────────────────── */
  function initDynamicHeadline() {
    var params = new URLSearchParams(window.location.search);
    var angle  = params.get('angle') || 'default';

    var headlines = {
      price:     { h: 'Pay ₹366/mo — Own the <em>Best</em> Durex Has Made', sub: 'EMI available. No-cost option from HDFC, ICICI & Bajaj Finserv.' },
      sensation: { h: 'Engineered to <em>Feel Different</em> From Anything Else', sub: 'FlexFit™ TPE adapts perfectly. 473 men agree.' },
      proof:     { h: 'Rated 4.5 Stars by <em>473 Verified</em> Buyers', sub: 'India\'s highest-rated personal wellness sleeve. Direct from Durex.' },
      'default': null
    };

    var config = headlines[angle];
    if (!config) return;

    var hEl   = document.querySelector('[data-dsr-headline]');
    var subEl = document.querySelector('[data-dsr-sub]');

    if (hEl)   hEl.innerHTML   = config.h;
    if (subEl) subEl.textContent = config.sub;
  }

  /* ─────────────────────────────────────────────
   * Init all on DOMContentLoaded
   * ───────────────────────────────────────────── */
  function init() {
    initGallery();
    initBenefitTabs();
    initFAQ();
    initStickyBar();
    initReveal();
    initWhatsAppCapture();
    initVariantSelector();
    initDynamicHeadline();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();